module.exports = __webpack_public_path__ + "img/mediavault_opentext.65da089b.jpg";